import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SavingsPlanSocialProof } from '@shared/models/CustomerAccount';
import { EstimatedValues } from '@shared/models/Reporting';

@Component({
  selector: 'app-social-proof',
  templateUrl: './social-proof.component.html',
  styleUrls: ['./social-proof.component.scss'],
  standalone: false
})
export class SocialProofComponent {
  @Input() currency: string;
  @Input() estimatedPeriod: number;
  @Input() estimatedValues: EstimatedValues;
  @Input() expectedPercentages: { loss: number; expected: number; good: number };
  @Input() kind: string;
  @Input() language: string;
  @Input() savingsPlanSocialProof: SavingsPlanSocialProof | null;
  @Input() showDetails: boolean;
  @Input() hideSavingsPlan: boolean;
  @Output() toggleDetails = new EventEmitter<string>();

  get difference() {
    return Math.abs(this.estimatedValues.expected - this.estimatedValues.expectedWithout);
  }

  get knobPosition() {
    if (this.savingsPlanSocialProof === null) {
      return 0;
    }
    return `${
      (Math.abs(this.savingsPlanSocialProof.average - this.savingsPlanSocialProof.below_average) * 100) /
      (this.savingsPlanSocialProof.above_average - this.savingsPlanSocialProof.below_average)
    }%`;
  }

  onToggleDetails() {
    this.toggleDetails.emit('[Button] SP proof: Toggle details');
  }
}
